// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__PpqU7","aside":"styles_aside__lZVD8","globe":"styles_globe__3GQP_"};